<template lang="pug">
    el-dialog(
        :title="modal.title"
        :visible.sync="modal.visibility"
        :before-close="confirmDiscard(() => changedSince(modal.formSnapshot, modal.form))"
        :close-on-click-modal="false"
        :append-to-body="true"
        top="10vh"
        :width="width"
        @opened="modal.formSnapshot = snapshotOf(modal.form)"
        @close="$emit('close')"
        @closed="resetModal"
    )
        .modal-body
            el-form.panel-form.el-form--label-left(
                ref="modal"
                :model="modal.form"
                :rules="modal.rules"
                @submit.native.prevent
            )
                el-form-item.no-margin(prop="name" :label="$t('Name')")
                    el-input(ref="name" v-model="modal.form.name")
                el-form-item.less-margin(prop="discard_remaining_amount")
                    el-checkbox(v-model="autoApply") {{ $t('Apply this coupon automatically') }}

                //- el-form-item(prop="description" :label="$t('Description')")
                    quill-editor(v-model="modal.form.description" :options="quillConfig")

                transition(name="slide-decent-vertical" mode="out-in")
                    el-form-item.no-margin(v-if="!autoApply" prop="code" :label="$t('Code')")
                        el-input(v-model="modal.form.code")

                el-form-item.switches
                    el-switch(
                        :active-text="$t('Fixed amount')"
                        active-value="fixed"
                        :inactive-text="$t('Percentage')"
                        inactive-value="percentage"

                        v-model="modal.form.type"
                    )


                .amount(v-if="modal.form.type === 'fixed'" key="amount")
                    //- el-form-item(prop="amount" :label="modal.form.tax !== null ? $t('Amount') : null")
                    el-form-item.no-margin(prop="amount" :label="$t('Amount')")
                        el-input(type="number" v-model="amount" step="0.01" min="0")
                            template(slot="append")
                                i.el-icon-fa-euro-sign.fas(v-if="currency === '€'")
                                i.el-icon-fa-dollar-sign.fas(v-else-if="currency === '$'")
                                b.currency(v-else) {{ currency }}
                    el-form-item.less-margin(prop="discard_remaining_amount")
                        el-checkbox(
                            v-model="modal.form.discard_remaining_amount"
                            :disabled="!maxUsesPerCustomer && maxUses !== 1"
                        ) {{ $t('Discard the remaining amount') }}

                .percentage(v-else key="percentage")
                    el-form-item(prop="percentage" :label="$t('Percentage')")
                        el-input(type="number" v-model="percentage" step="0.01" min="0.01" max="100")
                            template(slot="append")
                                i.el-icon-fa-percentage.fas

                .max-uses
                    el-form-item(prop="max_uses" :label="$t('Max. uses')")
                        el-input-number(
                            type="number"
                            :min="1"
                            v-model="maxUses"
                            controls-position="right"
                            placeholder="∞"
                        )
                        //- el-input(
                        //-     type="number"
                        //-     v-model="modal.form.max_uses"
                        //-     step="1"
                        //-     min="1"
                        //-     placeholder="∞"
                        //- )
                    el-form-item(prop="max_uses_per_customer" :label="$t('Max. uses per customer')")
                        el-input-number(
                            type="number"
                            :min="1"
                            v-model="maxUsesPerCustomer"
                            controls-position="right"
                            placeholder="∞"
                        )
                        //- el-input(
                        //-     type="number"
                        //-     v-model="modal.form.max_uses_per_customer"
                        //-     step="1"
                        //-     min="1"
                        //-     placeholder="∞"
                        //- )
                el-form-item(prop="position" :label="$t('Priority')")
                    el-input-number(
                        type="number"
                        :min="1"
                        v-model="position"
                        controls-position="right"
                    )
                    //- el-input(
                    //-     type="number"
                    //-     v-model="modal.form.position"
                    //-     step="1"
                    //-     min="1"
                    //- )
                el-form-item(v-if="showApplicableFor" prop="applicable_for" :label="$t('Applicable for')")
                    el-select.is-full-width(
                        placeholder=""
                        v-model="applicableFor"
                        :loading="options.applicableFor.loading"
                        :value="$t(applicableFor)"
                        :disabled="!!customer"
                    )
                        el-option(
                            v-for="item in options.applicableFor.items"
                            :key="item.value"
                            :label="$t(item.label)"
                            :value="item.value"
                        )

                //- Customer selection when applicable_for is 'customer'

                transition(name="slide-fade")
                    .customer-selection(v-if="showApplicableFor && applicableFor === 'customer'")
                        el-form-item(prop="_customersValidation" :label="$t('Customers')")
                            el-autocomplete.customer-autocomplete(
                                v-model="customerSearch"
                                value-key="name"
                                :fetch-suggestions="autocompleteCustomer"
                                :placeholder="$t('Find customer...')"
                                @select="selectCustomer"
                                @keydown.escape.native="resetCustomerSearch"
                                @keydown.enter.native.prevent
                                @clear="resetCustomerSearch"
                            )
                                template(slot="prefix")
                                    i.fas.el-icon-fa-magnifying-glass
                                template(slot-scope="{ item }")
                                    .autocomplete-item
                                        .flex-row
                                            .customer-nr(v-if="item.customer") \#{{ item.customer.nr }}
                                            b.name {{ item.name }}
                                            .email {{ item.email }}
                            transition(name="slide-fade")
                                .selected-customers(v-if="selectedCustomers && selectedCustomers.length")
                                    el-tag(
                                        v-for="item in selectedCustomers"
                                        :key="item.id"
                                        :closable="!customer || !item.nr || customer.id != item.id"
                                        size="medium"
                                        @close="removeCustomer(item)"
                                    )
                                        span(v-if="item.nr") \#{{ item.nr }}
                                        |  {{ getCustomerDisplayName(item) }}

                //- Customer group selection when applicable_for is 'customer-group'

                transition(name="slide-fade")
                    el-form-item(
                        v-if="showApplicableFor && applicableFor === 'customer-group'"
                        prop="customerGroups"
                        :label="$t('Customer Groups')"
                    )
                        el-select.is-full-width(
                            v-model="selectedCustomerGroups"
                            multiple
                            :loading="options.customerGroup.loading"
                            :placeholder="$t('Select customer groups')"
                        )
                            el-option(
                                v-for="group in options.customerGroup.items"
                                :key="group.id"
                                :label="group.name"
                                :value="group.id"
                            )
                .datepickers
                    el-form-item(prop="start_at" :label="$t('Cannot be redeemed before')")
                        el-date-picker(
                            v-model="startAt"
                            type="datetime"
                            :format="$t('yyyy-MM-dd') + ' HH:mm'"
                            prefix-icon="far el-icon-fa-calendar-alt"
                            :picker-options="{firstDayOfWeek:1, disabledDate: disabledStartDate}"
                        )
                    el-form-item(prop="end_at" :label="$t('Cannot be redeemed after')")
                        el-date-picker(
                            v-model="endAt"
                            type="datetime"
                            :format="$t('yyyy-MM-dd') + ' HH:mm'"
                            prefix-icon="far el-icon-fa-calendar-alt"
                            :picker-options="{firstDayOfWeek:1, disabledDate: disabledEndDate}"
                        )
                el-form-item(prop="discard_the_following_coupons")
                    el-checkbox(v-model="modal.form.discard_the_following_coupons") {{ $t('Discard the following coupons/discounts') }}
        .modal-footer
            .left
                slot(name="footer-left" v-bind:closeModal="closeModal" v-bind:submit="submit")
            .right
                slot(name="footer-right" v-bind:closeModal="closeModal" v-bind:submit="submit")
                    el-button(
                        size="mini"
                        icon="el-icon-fa-times fas"
                        @click="closeModal"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        size="mini"
                        type="primary"
                        icon="el-icon-fa-check fas"
                        @click="submit()"
                    ) {{ submitButtonLabel || $t('Ok') }}
</template>

<i18n>
{
    "en": {
        "Coupon for {customer}": "Coupon for {customer}",
        "Unlink {type} from {customer}": "Unlink {type} from {customer}",
        "Link {type} to {customer}": "Link {type} to {customer}",
        "Used by {customer}": "Used by {customer}"
    },
    "de": {
        "Coupon": "Gutschein",
        "Coupon for {customer}": "Gutschein für {customer}",
        "Priority": "Priorität",
        "Amount": "Betrag",
        "Fixed amount": "Fester Betrag",
        "Percentage": "Prozentsatz",
        "Code": "Code",
        "Name": "Bezeichnung",
        "Apply this coupon automatically": "Diesen Gutschein automatisch anwenden",
        "Description": "Beschreibung",
        "Net": "Netto",
        "Gross": "Brutto",
        "Max. uses": "Max. Anzahl der Verwendungen",
        "Max. uses per customer": "Verwendungen pro Kunde",
        "Cannot be redeemed before": "Nicht einlösbar vor",
        "Cannot be redeemed after": "Nicht einlösbar nach",
        "Unlink {type} from {customer}": "Verknüpfung von {customer} lösen",
        "Link {type} to {customer}": "Mit {customer} verknüpfen",
        "Used by {customer}": "Eingelöst von {customer}",
        "Total uses": "Eingelöst insgesamt",
        "Discard the following coupons/discounts": "Nachfolgende Gutscheine/Rabatte verwerfen",
        "Discard the remaining amount": "Restbetrag verwerfen",
        "Applicable for": "Einlösbar von",
        "Anyone": "Jedem",
        "all": "Jedem",
        "Customer": "Kunde",
        "Customers": "Kunden",
        "New Customer": "Neuer Kunde",
        "New Customers": "Neue Kunden",
        "Customer Group": "Kundengruppe",
        "Customer Groups": "Kundengruppen",
        "Select customer groups": "Kundengruppen auswählen",
        "Find customer...": "Kunden finden...",
        "Guest": "Gast",
        "Guests": "Gäste",
        "Please select at least one customer": "Bitte wählen Sie mindestens einen Kunden aus",
        "Please select at least one customer group": "Bitte wählen Sie mindestens eine Kundengruppe aus"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { useSetupStore, useShopCouponStore } from '@/stores'
import pinia from '@/pinia'
import { fromUnixTime, compareAsc, compareDesc, addDays, getUnixTime } from 'date-fns'
import { appFromUnixTime, appGetUnixTime } from '@/utils/timezone'

import quillConfig from '@/quill/config'
import MemberApi from '@/extensions/restrictedArea/store/api/member';
import discardGuard from '@/mixins/discardGuard';

export default {
    name: 'CouponForm',
    mixins: [discardGuard],
    props: {
        data: {
            type: Object,
            required: true
        },
        customer: {
            type: Object,
            required: false
        },
        // options: {
        //     type: Object,
        //     required: true,
        // },
        showApplicableFor: {
            type: Boolean,
            default: true,
        },
        visibility: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '520px',
        },
        submitButtonLabel: {
            type: String,
        }
    },
    data() {
        return {
            modal: {
                visibility: false,
                title: '',
                form: {},
                rules: {},
                formSnapshot: undefined,
            },
            quillConfig,
            customerSearch: '',
        }
    },
    watch: {
        visibility(visible) {
            if (visible) this.openModal()
            else this.closeModal()
        },
        applicableFor(value) {
            this.updateApplicableForRules(value)
        }
    },
    computed: {
        currency() {
            const currency = _.get(this.customer, 'customerGroup.currency')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency')

            // get from default group of active shop config
            const sign = _.get(currency, 'sign');
            const code = _.get(currency, 'code') || _.get(currency, 'iso4217');

            return sign || code;
        },

        autoApply: {
            get() {
                return this.modal.form.code === null || this.modal.form.code === undefined
            },
            set(value) {
                if (value) {
                    this.$set(this.modal.form, 'code', null)
                } else if (!this.modal.form.code) {
                    this.$set(this.modal.form, 'code', '')
                }
            }
        },

        amount: {
            get() {
                return this.modal.form.amount
            },
            set(value) {
                // this.modal.form.amount = parseFloat(value)
                this.$set(this.modal.form, 'amount', value ? parseFloat(value) : null)
            }
        },

        percentage: {
            get() {
                return this.modal.form.percentage
            },
            set(value) {
                // this.modal.form.percentage = parseFloat(value)
                this.$set(this.modal.form, 'percentage', value ? parseFloat(value) : null)
            }
        },

        maxUses: {
            get() {
                let maxUses = this.modal.form.max_uses
                if (! maxUses) maxUses = undefined
                return maxUses
            },
            set(value) {
                if (!value) value = null
                this.modal.form.max_uses = value
            }
        },
        maxUsesPerCustomer: {
            get() {
                let maxUsesPerCustomer = this.modal.form.max_uses_per_customer
                if (! maxUsesPerCustomer) maxUsesPerCustomer = undefined
                return maxUsesPerCustomer
            },
            set(value) {
                if (!value) value = null
                this.modal.form.max_uses_per_customer = value
            }
        },

        position: {
            get() {
                let position = this.modal.form.position
                if (! position) position = undefined
                return position
            },
            set(value) {
                if (!value) value = null
                this.modal.form.position = value
            }
        },

        startAt: {
            get() {
                const start =  _.get(this.modal.form, 'start_at')
                return start ? appFromUnixTime(start) : ''
            },
            set(value) {
                const start = value !== null ? appGetUnixTime(value) : null
                this.modal.form.start_at = start;
            }
        },
        endAt: {
            get() {
                const end = _.get(this.modal.form, 'end_at')
                return end ? appFromUnixTime(end) : ''
            },
            set(value) {
                const end = value !== null ? appGetUnixTime(value) : null
                this.modal.form.end_at = end;
            }
        },
        applicableFor: {
            get() {
                return _.get(this.modal.form, 'applicable_for') || 'anyone'
            },
            set(value) {
                this.$set(this.modal.form, 'applicable_for', value)
                // Clear customers/customerGroups when switching applicable_for type
                if (value !== 'customer') {
                    this.$set(this.modal.form, 'customers', [])
                    this.$set(this.modal.form, 'members', [])
                }
                if (value !== 'customer-group') {
                    this.$set(this.modal.form, 'customerGroups', [])
                }
            }
        },
        selectedCustomers() {
            // Combine customers and members for display
            const customers = _.get(this.modal.form, 'customers') || []
            const members = _.get(this.modal.form, 'members') || []
            return [...customers, ...members]
        },
        selectedCustomerGroups: {
            get() {
                const groups = _.get(this.modal.form, 'customerGroups') || []
                return groups.map(g => g.id || g)
            },
            set(value) {
                // Convert IDs back to objects with id property
                const groups = value.map(id => {
                    const existing = this.options.customerGroup.items.find(g => g.id === id)
                    return existing || { id }
                })
                this.$set(this.modal.form, 'customerGroups', groups)
            }
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
        shopCouponStore() {
            return useShopCouponStore(pinia);
        },
        options() {
            return this.shopCouponStore.options;
        }
    },
    methods: {
        openModal() {
            this.modal.visibility = true
            this.$emit('update:visibility', true)

            this.$set(this.modal, 'form', _.cloneDeep(this.data))

            if (this.customer) {
                this.modal.title = this.$t('Coupon for {customer}', { customer: this.getCustomerDisplayName(this.customer) })
            } else {
                this.modal.title = this.$t('Coupon')
            }

            const shop = this.activeCms.shop

            let codeRule =  `required|min:3|unique_coupon_code:"shop":${shop.id}`
            if (! this.modal.form.id.startsWith('new')) codeRule += `,"coupon":${this.modal.form.id}`

            let rules = {
                name: 'min:3',
                code: codeRule,
                amount: 'required',
                percentage: 'required|min_value:0.01|max_value:100',
                max_uses: 'min_value:1',
                max_uses_per_customer: 'min_value:1',
                position: 'min_value:1',
                start_at: 'min_value:1',
                end_at: 'min_value:1',
            }

            this.$set(this.modal, 'rules', rules)

            // Set validation rules for applicable_for related fields
            this.updateApplicableForRules(this.applicableFor)

            // NOTE: nextTick does not work
            setTimeout(() => {
                // this.$refs.modal.resetFields()
                this.$refs.modal.clearValidate()
            }, 0)

            this.$nextTick(() => {
                this.$refs.name.focus()
            })
        },
        closeModal() {
            this.$emit('close')
            this.modal.visibility = false
            this.$emit('update:visibility', false)
            this.$refs.modal.resetFields()
        },
        resetModal() {
            this.$emit('closed')
            this.$emit('update:visibility', false)
            this.$refs.modal.resetFields()
            this.modal = {
                visibility: false,
                title: '',
                form: {},
                rules: {},
            }
        },
        submit(close = true) {
            this.$refs.modal.validate(valid => {
                if (valid) {
                    let data = _.cloneDeep(this.modal.form)

                    if (data.max_uses === undefined) data.max_uses = null;
                    if (data.max_uses_per_customer === undefined) data.max_uses_per_customer = null;

                    // Remove validation helper field before submitting
                    delete data._customersValidation

                    this.$emit('submit', data)
                    if (close) this.closeModal()
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        disabledStartDate(start) {
            const end = this.modal.form.end_at
            if (end) return compareAsc(start, appFromUnixTime(end)) > 0
            else return false
        },
        disabledEndDate(end) {
            const start = this.modal.form.start_at
            if (start) return compareDesc(addDays(end, 1), appFromUnixTime(start)) > 0
            else return false
        },
        async autocompleteCustomer(query, callback) {
            if (!query) return callback([])

            try {
                const members = await MemberApi.autocomplete(this.activeCms.id, query)
                // Filter out already selected customers/members
                const selectedCustomerIds = (_.get(this.modal.form, 'customers') || []).map(c => c.id)
                const selectedMemberIds = (_.get(this.modal.form, 'members') || []).map(m => m.id)
                const filtered = members.filter(m => {
                    if (m.customer) {
                        return !selectedCustomerIds.includes(m.customer.id)
                    }
                    return !selectedMemberIds.includes(m.id)
                })
                callback(filtered)
            } catch (err) {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
                console.error(err)
                callback([])
            }
        },
        selectCustomer(member) {
            this.customerSearch = ''
            // If member has a customer relation, store the customer with member info attached
            // Otherwise store the member directly
            if (member.customer) {
                const customers = _.get(this.modal.form, 'customers') || []
                if (!customers.find(c => c.id === member.customer.id)) {
                    const customer = _.cloneDeep(member.customer)
                    customer.member = _.cloneDeep(member)
                    delete customer.member.customer
                    customers.push(customer)
                    this.$set(this.modal.form, 'customers', customers)
                }
            } else {
                const members = _.get(this.modal.form, 'members') || []
                if (!members.find(m => m.id === member.id)) {
                    members.push(_.cloneDeep(member))
                    this.$set(this.modal.form, 'members', members)
                }
            }
            // Trigger validation by updating combined count
            this.updateCustomersValidationField()
        },
        removeCustomer(item) {
            // Check if it's a customer (has nr) or a member
            if (item.nr !== undefined) {
                const customers = _.get(this.modal.form, 'customers') || []
                this.$set(this.modal.form, 'customers', customers.filter(c => c.id !== item.id))
            } else {
                const members = _.get(this.modal.form, 'members') || []
                this.$set(this.modal.form, 'members', members.filter(m => m.id !== item.id))
            }
            // Trigger validation by updating combined count
            this.updateCustomersValidationField()
        },
        updateCustomersValidationField() {
            // Create a combined array for validation purposes
            // This ensures the 'required' rule works with both customers and members
            const customers = _.get(this.modal.form, 'customers') || []
            const members = _.get(this.modal.form, 'members') || []
            const combined = [...customers, ...members]
            // Store as a validation helper field
            this.$set(this.modal.form, '_customersValidation', combined.length > 0 ? combined : null)
        },
        resetCustomerSearch() {
            this.customerSearch = ''
        },
        getCustomerDisplayName(item) {
            // For customers with member info
            if (item.member) {
                const firstName = _.get(item, 'member.first_name', '')
                const lastName = _.get(item, 'member.last_name', '')
                return _.trim(`${firstName} ${lastName}`) || item.member.email || ''
            }
            // For members without customer relation
            const firstName = _.get(item, 'first_name', '')
            const lastName = _.get(item, 'last_name', '')
            return _.trim(`${firstName} ${lastName}`) || item.email || ''
        },
        updateApplicableForRules(value) {
            if (!this.showApplicableFor) return

            // Clear previous rules
            this.$delete(this.modal.rules, '_customersValidation')
            this.$delete(this.modal.rules, 'customerGroups')

            // Add required rule based on selection
            if (value === 'customer') {
                this.$set(this.modal.rules, '_customersValidation', 'required')
                // Initialize validation field
                this.updateCustomersValidationField()
            } else if (value === 'customer-group') {
                this.$set(this.modal.rules, 'customerGroups', 'required')
            }
        },
    },
    mounted() {
        if (this.visibility === true) {
            this.openModal();
        }
        // Fetch customer groups for the select dropdown
        const shopId = _.get(this.activeCms, 'shop.id')
        if (this.showApplicableFor && shopId) {
            this.shopCouponStore.fetchCustomerGroupOptions(shopId);
        }
    }
}
</script>

<style lang="sass" scoped>
.modal-body
    .max-uses,
    .datepickers
        display: flex
        gap: 1rem
        .el-form-item
            flex-grow: 1
            flex-basis: 50%
    .net-gross-switch
        white-space: nowrap
        margin-left: 1rem
    .switches
        padding-top: 2rem
        &::v-deep .el-form-item__content
            display: flex
            /* justify-content: space-between */
            .spacer
                flex-grow: 1
    .amount::v-deep .el-form-item__label,
    .percentage::v-deep .el-form-item__label
        display: none

.modal-body::v-deep
    .el-form-item__content:before
        clear: both
.modal-footer
    display: flex
    justify-content: space-between
    .left
        display: flex
        align-items: center

.el-input-number--medium,
.el-input--medium
    width: 100%
    &::v-deep input
        text-align: left
.el-form-item.no-margin
    margin-bottom: 0
    &.is-error
        margin-bottom: 1rem

.customer-selection
    .selected-customers
        display: flex
        flex-wrap: wrap
        gap: 8px
        margin-top: 12px
        .el-tag
            height: 32px
            line-height: 30px
    .customer-autocomplete
        width: 100%
        &::v-deep .el-input__prefix
            display: flex
            justify-content: center
            align-items: center
            width: 24px

.autocomplete-item
    padding: 0.5rem 0
    line-height: 1.3
    .flex-row
        display: flex
        align-items: center
        gap: 8px
    .customer-nr
        color: #909399
        font-size: 12px
    .email
        color: #909399
        font-size: 12px
        margin-left: auto

.less-margin
    margin-bottom: 0.5rem

body .el-tag + .el-tag
    margin-left: 0
</style>
